import React from "react";
import styles from "./DistrictTable.module.css";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import cx from "classnames";
import Alert from "@material-ui/lab/Alert";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "District",
  },
  { id: "confirmed", numeric: true, disablePadding: true, label: "C" },
  { id: "active", numeric: true, disablePadding: false, label: "A" },
  { id: "recovered", numeric: true, disablePadding: true, label: "R" },
  { id: "deceased", numeric: true, disablePadding: false, label: "D" },
];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            className={styles.head}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              className={styles.head}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,

  onRequestSort: PropTypes.func.isRequired,

  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 90,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

export default function District({ district }) {
  const classes = useStyles();
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("confirmed");
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const rows = [];
  function createData(name, confirmed, active, recovered, deceased) {
    rows.push({ name, confirmed, active, recovered, deceased });
  }
  var distsize = Object.keys(district).length;
  console.log(distsize);
  const addDistricts = () => {
    for (var a = 0; a < distsize; a++) {
      var name = Object.keys(district)[a];
      var confirmed = district[name]?.total?.confirmed
        ? district[name]?.total?.confirmed
        : "NA";
      var recovered = district[name]?.total?.recovered
        ? district[name]?.total?.recovered
        : "NA";
      var deceased = district[name]?.total?.deceased
        ? district[name]?.total?.deceased
        : "NA";
      var active = confirmed - (recovered + deceased);
      active = !isNaN(active) ? active : "NA";
      createData(name, confirmed, active, recovered, deceased);
    }
  };

  return (
    <div className={cx(classes.root, styles.container)}>
      <div className={styles.container}>
        <Alert severity="info">
          C-Confirmed, A-Active, R-Recovered, D-Deceased
        </Alert>
        <Paper className={classes.paper}>
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="medium"
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {addDistricts()}
                {stableSort(rows, getComparator(order, orderBy)).map(
                  (row, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow>
                        <TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          className={styles.headside}
                          style={{ minWidth: 70, maxWidth: 99 }}
                        >
                          {row.name}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="none"
                          style={{ minWidth: 20, maxWidth: 20 }}
                        >
                          {row.confirmed}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{ minWidth: 20, maxWidth: 20 }}
                        >
                          {row.active}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="none"
                          style={{ minWidth: 20, maxWidth: 20 }}
                        >
                          {row.recovered}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{ minWidth: 10, maxWidth: 10 }}
                        >
                          {row.deceased}
                        </TableCell>
                      </TableRow>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    </div>
  );
}
